function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Working"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M207,0H218.8V56.06H207Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M156.57,32.37A18.7,18.7,0,0,0,137.89,16c-4.57,0-8.46,1.76-10.92,5.12l-.13.17V0H115V38.33h.08c.93,11.8,9.43,18.76,20.68,18.76,12.4,0,21.09-8.45,21.09-21A24.53,24.53,0,0,0,156.57,32.37ZM135.84,46A8.59,8.59,0,0,1,127,38.28a11.88,11.88,0,0,1-.13-1.72,12.13,12.13,0,0,1,.13-1.73,10.59,10.59,0,0,1,.66-2.46,9,9,0,0,1,16.42,0,11,11,0,0,1,.79,4.19C144.84,42.17,141.21,46,135.84,46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M181.41,26.61a12,12,0,0,0-1.49.09,12,12,0,0,1,1.49-.09Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M176.65,27.68a9.11,9.11,0,0,1,3.27-1A9.11,9.11,0,0,0,176.65,27.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M188.26,29.25a7.36,7.36,0,0,0-1-.89A7.36,7.36,0,0,1,188.26,29.25Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M173.83,30.38a7.42,7.42,0,0,1,.79-1.09A7.42,7.42,0,0,0,173.83,30.38Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M175.57,28.39a7.74,7.74,0,0,1,1.08-.71A7.74,7.74,0,0,0,175.57,28.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M190,32.37h0a8.89,8.89,0,0,0-1.76-3.12A8.89,8.89,0,0,1,190,32.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M175.57,28.39a7.34,7.34,0,0,0-.95.9A7.34,7.34,0,0,1,175.57,28.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M202.18,36.56a23.84,23.84,0,0,0-.37-4.19C200.06,22.72,192.23,16,181.41,16s-18.82,6.69-20.62,16.34a22.91,22.91,0,0,0-.38,4.19,22.56,22.56,0,0,0,.24,3.32c1.46,10.11,9.63,17.21,20.76,17.21,9.72,0,17.14-5.37,19.66-13.42H188.84c-1.5,2.13-4,2.84-7.43,2.84-4.26,0-7.73-2.06-8.68-6.63h29.45ZM190,32.37H173a9.27,9.27,0,0,1,.87-2,7.42,7.42,0,0,1,.79-1.09,7.34,7.34,0,0,1,.95-.9,7.74,7.74,0,0,1,1.08-.71,9.11,9.11,0,0,1,3.27-1,12,12,0,0,1,1.49-.09h0l.76,0a10.71,10.71,0,0,1,2.79.51,7.51,7.51,0,0,1,2.33,1.22,7.36,7.36,0,0,1,1,.89A8.89,8.89,0,0,1,190,32.37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M181.41,26.61h0l.76,0Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M182.17,26.63a10.71,10.71,0,0,1,2.79.51A10.71,10.71,0,0,0,182.17,26.63Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M109.61,28.74C106.74,20.79,99.56,16,90.2,16c-12.4,0-21.08,8.45-21.08,21v.22C69.23,50.68,79.35,57.09,88,57.09c5.39,0,9.67-2.49,11.82-7l.26,4.53v1.4H111V37A24.2,24.2,0,0,0,109.61,28.74ZM90.12,46c-5.15,0-8.69-3.55-9-8.78q0-.34,0-.69c0-5.61,3.63-9.48,9-9.48a8.58,8.58,0,0,1,8.8,7.28,12,12,0,0,1,.2,2.2c0,.28,0,.55,0,.83C98.75,42.54,95.22,46,90.12,46Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M45.9,17.23c-5.4,0-10,1.47-13.3,4.39-3.34-2.93-7.92-4.39-13.33-4.39C7.74,17.23,0,23.94,0,37.05V57.26H11.84V37.05c0-6.16,3-8.77,7.43-8.77,4.13,0,7,2.28,7.38,7.62,0,.37,0,.76,0,1.15V57.26h11.9V37.05c0-.39,0-.78,0-1.15.36-5.34,3.25-7.62,7.39-7.62,4.42,0,7.42,2.61,7.42,8.77V57.26H65.16V37.05C65.16,23.86,57.42,17.23,45.9,17.23Z"
})));

var SvgMabelLogoWhiteRgb = function SvgMabelLogoWhiteRgb(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 218.8 57.26",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMabelLogoWhiteRgb, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Mabel_Logo_White_RGB.0adb407b.svg";
export { ForwardRef as ReactComponent };